import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserNotification } from '@interfaces/Reminder';

@Injectable({ providedIn: 'root' })
export class UserNotificationActionService {
  constructor(private readonly router: Router) {}

  canNavigate(notification: UserNotification): boolean {
    return (
      notification.action?.kind === 'ORDER' &&
      Boolean(notification.action.entityId)
    );
  }

  navigate(notification: UserNotification): Promise<boolean> | null {
    if (!this.canNavigate(notification)) return null;
    return this.router.navigate(['/orders', notification.action!.entityId]);
  }
}
